
import Vue from 'vue'
import XTable from 'vux/src/components/x-table/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

var PersonChangePage = Vue.extend({})
Vue.component('personChange-page', PersonChangePage)

export default {
name: 'PersonChangePage',
components: {
XTable,XButton
},
props: {
idArr: Array
},
data () {
return {
baseUrl: this.$store.state.url,
info: {}
}
},
mounted () {
this.$vux.loading.show({
text: '加载中'
});
this.axios({
url: this.baseUrl+'/wechat/personnelChange/getJson/'+this.idArr[0],
method: 'get'
}).then((response) => {
this.info = response.data.data.info;
this.$vux.loading.hide();
}).catch((response) => {
});
},
methods: {
showImg (src) {
if(Object.keys(this.otherMap).length == 0){
this.$vux.alert.show({
title: '暂无数据'
});
setTimeout(() => {
this.$vux.alert.hide();
}, 2000)
}else{
let imgSrc = this.otherMap['image'+src]+'?number='+Math.random();
let imgSrcArr = [];
imgSrcArr.push(imgSrc);
wx.previewImage({
current: imgSrc, // 当前显示图片的http链接
urls: imgSrcArr 
});
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/detail/todo/hr/personChange.vue